import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'app/rootReducer'
import './styles.scss'
import GoBackHeader from 'components/organisms/GoBackHeader'
import Avatar from 'components/atoms/Avatar'

const LawFirmInformation = (): JSX.Element => {
  const activeCase = useSelector((state: RootState) => state.activeCase)
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { firm } = activeCase.matter!
  return (
    <React.Fragment>
      <GoBackHeader text='Law Firm Information' />
      <div className='ui-lawfirm-info-page' data-testid='lawfirm-info-page'>
        <div data-testid='lawfirm-info-avatar'>
          <Avatar
            icon={firm.iconUrl}
            name={firm.name}
            email={firm.emailAddress}
          />
        </div>
        <div className='mt-3 display-flex'>
          <div className='mdi mdi-gavel' />
          <div>
            <strong>Office Id</strong>
            <div data-testid='lawfirm-info-office-id'>
              {activeCase.matter?.firm.officeId}
            </div>
          </div>
        </div>
        <div className='mt-3 display-flex' data-testid='lawfirm-info-address'>
          <div className='mdi mdi-home' />

          <div>
            <strong>Address</strong>
            <br />
            <span>{activeCase.matter?.firm.street}</span>
            <br />
            <span>
              {activeCase.matter?.firm.city}, {activeCase.matter?.firm.state}{' '}
              {activeCase.matter?.firm.zip}
            </span>
          </div>
        </div>
        <div className='mt-3 display-flex'>
          <div className='mdi mdi-phone' />
          <div>
            <strong>Phone</strong>
            <div>
              <a
                href={`tel:${activeCase.matter?.firm.phone}`}
                data-testid='lawfirm-info-phone-link'
              >
                {activeCase.matter?.firm.phone}
              </a>
            </div>
          </div>
        </div>
        <div className='mt-3 display-flex'>
          <div className='mdi mdi-fax' />
          <div>
            <strong>Fax</strong>
            <div data-testid='lawfirm-info-fax-link'>
              <a
                href={`tel:${activeCase.matter?.firm.fax}`}
                data-testid='lawfirm-info-fax-link'
              >
                {activeCase.matter?.firm.fax}
              </a>
            </div>
          </div>
        </div>
        <div className='mt-3 display-flex'>
          <div className='mdi mdi-monitor' />
          <div>
            <strong>Website</strong>
            <div>
              <a
                href={'' + activeCase.matter?.firm.website}
                rel='noopener noreferrer'
                target='_blank'
                data-testid='lawfirm-info-website-link'
              >
                {activeCase.matter?.firm.website}
              </a>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default LawFirmInformation
